import React from "react";
import { Link } from "react-router-dom";
import { Header } from "../components/Header";
import { ChevronLeft, Wind, AlertTriangle, BookOpen, Shield, MessageCircle, Heart, Unlock, ClipboardList, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const ORIENTATIONS = [
  {
    situation: "Je suis en pleine crise d'angoisse",
    tools: [
      { name: "Cohérence cardiaque", desc: "Calmer votre système nerveux immédiatement", path: "/coherence" },
      { name: "Carnet de crise", desc: "Noter ce qui se passe pour mieux comprendre", path: "/crisis" }
    ]
  },
  {
    situation: "Je me dis des choses dures sur moi-même",
    tools: [
      { name: "Pour le moment", desc: "Défiger une phrase qui vous enferme", path: "/pour-le-moment" }
    ]
  },
  {
    situation: "Je suis en conflit avec quelqu'un",
    tools: [
      { name: "Accusation retournée", desc: "Sortir du reproche et reprendre votre responsabilité", path: "/accusation-retournee" }
    ]
  },
  {
    situation: "Je perds patience avec mon enfant",
    tools: [
      { name: "SOS parent", desc: "Reprendre le contrôle avant que la scène ne dégénère", path: "/sos-parent" }
    ]
  },
  {
    situation: "Je me sens attaqué(e) ou critiqué(e)",
    tools: [
      { name: "Boucliers Paradoxaux", desc: "Transformer une attaque en occasion de se protéger", path: "/boucliers" }
    ]
  },
  {
    situation: "Je veux mieux me connaître",
    tools: [
      { name: "Tests", desc: "Quelques questions pour mieux cerner vos points de travail", path: "/tests" }
    ]
  },
  {
    situation: "Je me sens bloqué(e), je ne sais pas par où commencer",
    tools: [
      { name: "Exercices pratiques", desc: "14 exercices concrets pour avancer pas à pas", path: "/exercises" }
    ]
  },
  {
    situation: "J'ai besoin de me calmer, tout de suite",
    tools: [
      { name: "Cohérence cardiaque", desc: "Respiration guidée 4s / 8s", path: "/coherence" },
      { name: "SOS mouvements oculaires", desc: "Suivre un point du regard pour redescendre", path: "/sos-yeux" }
    ]
  }
];

export default function OrientationPage() {
  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <Link to="/dashboard" className="text-sm text-[#6A7771] hover:text-[#6B8576] flex items-center gap-1 mb-6 transition-colors duration-200">
          <ChevronLeft className="w-4 h-4" strokeWidth={1.5} /> Retour
        </Link>

        <div className="mb-8">
          <h1 className="text-3xl font-semibold text-[#2C3531] mb-2" style={{ fontFamily: 'Outfit' }} data-testid="orientation-title">Quel outil pour moi maintenant ?</h1>
          <p className="text-[#6A7771] text-sm">Choisissez la phrase qui correspond le mieux à ce que vous vivez en ce moment.</p>
        </div>

        <div className="space-y-4">
          {ORIENTATIONS.map((item, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.04 }}
              className="bg-white border border-[#EBE7E0] rounded-3xl p-5 sm:p-6"
              data-testid={`orientation-${i}`}
            >
              <p className="text-sm font-semibold text-[#2C3531] mb-3" style={{ fontFamily: 'Outfit' }}>"{item.situation}"</p>
              <div className="space-y-2">
                {item.tools.map((tool, j) => (
                  <Link key={j} to={tool.path}
                    className="flex items-center gap-3 bg-[#FAF9F6] border border-[#EBE7E0]/50 rounded-2xl px-4 py-3 hover:bg-[#6B8576]/5 hover:border-[#6B8576]/20 transition-all duration-300 group"
                    data-testid={`orientation-link-${i}-${j}`}
                  >
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-[#2C3531]" style={{ fontFamily: 'Outfit' }}>{tool.name}</p>
                      <p className="text-xs text-[#6A7771]">{tool.desc}</p>
                    </div>
                    <ArrowRight className="w-4 h-4 text-[#6A7771] group-hover:text-[#6B8576] group-hover:translate-x-1 transition-all duration-300 flex-shrink-0" strokeWidth={1.5} />
                  </Link>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </main>
    </div>
  );
}
